import { Box } from "@chakra-ui/react";

const sketchStyle = {
	borderRadius: "10px",
	padding: "10px",
	backgroundColor: "var(--bs-body-bg)",	
	backgroundClip: "padding-box",
	border: "5px solid #666",
	transform: "skew(1deg)",
	fontFamily: "'Caveat', cursive, -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif"
};

export default function SketchContainer({ children }) {
	return (
		<Box m={8} marginRight="31vw" style={sketchStyle} className="sketch-container">
			<style>
				{`
					@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@400;700&display=swap');
					.sketch-container h1 {
						transform: skew(1deg);
						font-family: 'Caveat', cursive, -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
						font-size: 150%;
						color: #666 !important;
						font-weight: 700;
					}
				`}
			</style>
			<Box style={{transform: "skew(-1deg)"}}>
				{children}
			</Box>
		</Box>
	);
}